import { render, staticRenderFns } from "./VUserAvatar.vue?vue&type=template&id=1ae8cab8&"
import script from "./VUserAvatar.vue?vue&type=script&lang=ts&"
export * from "./VUserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./VUserAvatar.vue?vue&type=style&index=0&id=1ae8cab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports